import { useImageDimensionEffect } from 'approot/shared/images/images.hooks';
import { PagesPreviewModal } from '../../shared/pages-preview';
import {
  ImageLightbox,
  ImageLightboxImage,
  ImageLightboxWrapper,
} from 'approot/activity-builder/lightbox/activity-builder-image-lightbox.style';
import { ComponentImageContainer } from '../../component-image.style';

const SuggestedAnswerDrawViewImageModal = ({
  imageUrl,
  alt,
  onClose,
}: {
  imageUrl: string;
  alt?: string | null;
  onClose?: () => void;
}) => {
  const { imageDimensions, setContainerElement } = useImageDimensionEffect({
    imageUrl,
  });

  return (
    <PagesPreviewModal
      name="Image lightbox"
      close={onClose}
      content={
        <ImageLightbox>
          <ImageLightboxImage $isLoading={false}>
            <ImageLightboxWrapper ref={setContainerElement}>
              <ComponentImageContainer $imageHasLoaded>
                <img
                  src={imageUrl}
                  alt={alt || ''}
                  style={
                    imageDimensions
                      ? {
                          width: imageDimensions.width,
                          height: imageDimensions.height,
                        }
                      : undefined
                  }
                />
              </ComponentImageContainer>
            </ImageLightboxWrapper>
          </ImageLightboxImage>
        </ImageLightbox>
      }
    />
  );
};

export default SuggestedAnswerDrawViewImageModal;
